import ChartColor from './ChartColor.vue';
export default ChartColor;
